"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCertificate = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var PMaybe_1 = require("../../../lib/std/PMaybe/PMaybe.js");
var types_1 = require("../../../type_system/types.js");
var PCredential_1 = require("../../V1/Address/PCredential.js");
var PPubKeyHash_1 = require("../../V1/PubKey/PPubKeyHash.js");
var PDelegatee_1 = require("./PDelegatee.js");
var PMaybeInt = (0, PMaybe_1.PMaybe)(types_1.int);
exports.PCertificate = (0, pstruct_1.pstruct)({
    StakeRegistration: {
        stakeKey: PCredential_1.PCredential.type,
        deposit: PMaybeInt.type
    },
    StakeDeRegistration: {
        stakeKey: PCredential_1.PCredential.type,
        refound: PMaybeInt.type
    },
    Delegation: {
        delegator: PCredential_1.PCredential.type,
        delegatee: PDelegatee_1.PDelegatee.type
    },
    RegistrationAndDelegation: {
        delegator: PCredential_1.PCredential.type,
        delegatee: PDelegatee_1.PDelegatee.type,
        lovelacesDeposit: types_1.int
    },
    DRepRegistration: {
        drep: PCredential_1.PCredential.type,
        lovelacesDeposit: types_1.int
    },
    DRepUpdate: {
        drep: PCredential_1.PCredential.type
    },
    DRepDeRegistration: {
        drep: PCredential_1.PCredential.type,
        refound: types_1.int
    },
    PoolRegistration: {
        poolId: PPubKeyHash_1.PPubKeyHash.type,
        poolVFR: PPubKeyHash_1.PPubKeyHash.type,
    },
    PoolRetire: {
        poolId: PPubKeyHash_1.PPubKeyHash.type,
        epoch: types_1.int,
    },
    CommitteeHotAuthorization: {
        cold: PCredential_1.PCredential.type,
        hot: PCredential_1.PCredential.type
    },
    CommitteeResignation: {
        cold: PCredential_1.PCredential.type
    }
});
